var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import SimpleDiagramBase from './SimpleDiagramBase';
import { prepareDiagramData2D } from '../basics/Statistics';
import { setOrDef, setIfDef } from "../Helpers";
var Pictorial = /** @class */ (function (_super) {
    __extends(Pictorial, _super);
    function Pictorial() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: undefined,
        };
        _this.calcData = function (props) {
            var d = props.diagram;
            var stacked = d.stacked ? true : false;
            prepareDiagramData2D(props.diagram, {
                type: "pictorialBar",
                stack: stacked ? "1" : undefined,
                label: /* props.diagram.showPointLabels ? */ {
                    show: true,
                    position: 'top',
                } /*: undefined*/,
            }).then(function (data) {
                //                console.log(data);
                _this.setState({ data: data });
                if (_this.props.onFieldsLoaded)
                    _this.props.onFieldsLoaded(data.fields);
            });
        };
        _this.getOption = function () {
            var d = _this.props.diagram;
            if (!_this.state.data)
                return undefined;
            //        console.log(this.state.data);
            var stacked = d.stacked ? true : false;
            var mlsData = [];
            if (d.showMinLine)
                mlsData.push({
                    type: 'min',
                    label: {
                        formatter: '{c}',
                        fontSize: 18,
                        fontFamily: 'Arial',
                        align: 'right'
                    }
                });
            if (d.showMaxLine)
                mlsData.push({
                    type: 'max',
                    label: {
                        formatter: setIfDef(d.label, function (x) { return _this.getLabelFormatter(x); }),
                        distance: setIfDef(d.label, function (x) { return x.distance; }),
                        color: setIfDef(d.label, function (x) { return x.color; }),
                        fontSize: setOrDef(d.label, function (x) { return x.fontSize; }, 18),
                    }
                });
            var markLineSetting = (d.showMaxLine || d.showMinLine) ? {
                symbol: 'none',
                lineStyle: {
                    color: "#950014",
                    type: "solid",
                    width: 1,
                },
                data: mlsData
            } : undefined;
            var seriesData = [];
            var i = 0;
            var fullData = [];
            _.forEach(_this.state.data.data.series[0].data, function (val, idx) {
                fullData.push({ name: "full" + idx, value: d.maxValue, symbol: d.symbol });
                var ele = {
                    name: val.name,
                    type: 'pictorialBar',
                    animationDuration: 500,
                    data: [{
                            name: val.name,
                            value: val.value,
                            symbol: d.symbol
                        }],
                    markLine: markLineSetting,
                };
                ele.symbolBoundingData = d.maxValue;
                ele.z = 10;
                ele.symbolClip = true;
                ele.silent = true;
                //            ele.barCategoryGap = 0;
                if (d.color)
                    ele.color = d.color;
                seriesData.push(ele);
                i++;
            });
            seriesData.push({
                name: "full",
                type: "pictorialBar",
                animationDuration: 500,
                symbolBoundingData: d.maxValue,
                symbolClip: true,
                z: 1,
                data: fullData,
                color: setIfDef(d, function (x) { return x.fullColor; }),
                silent: true,
            });
            var axis1 = {
                data: [],
                axisTick: { show: false },
                axisLine: { show: false },
                axisLabel: { show: false }
            };
            var axis2 = {
                show: false,
                color: "#105010"
            };
            var yAxis = d.orientation === "horizontal" ? axis1 : axis2;
            var xAxis = d.orientation === "horizontal" ? axis2 : axis1;
            var fillAxis = function (what, data) {
                if (data) {
                    if (data.show)
                        what.show = data.show;
                    if (data.minValue)
                        what.min = data.minValue;
                    if (data.maxValue)
                        what.max = data.maxValue;
                    if (data.color) {
                        if (what.axisLine) {
                            if (what.axisLine.lineStyle)
                                what.axisLine.lineStyle.color = data.color;
                            else
                                what.axisLine.lineStyle = { color: data.color };
                        }
                        else
                            what.axisLine = { lineStyle: { color: data.color } };
                    }
                    if (data.hideLine && what)
                        what.axisLine = { show: false };
                    if (data.hideTick && what)
                        what.axisTick = { show: false };
                }
            };
            fillAxis(xAxis, d.axisX);
            fillAxis(yAxis, d.axisY);
            var option = {
                backgroundColor: _this.props.diagram.backgroundColor,
                /*            dataset: {
                                source: this.state.data.data
                            },*/
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    axisPointer: _this.props.diagram.showAxisPointer ? {
                        type: "shadow"
                    } : undefined
                },
                grid: [{
                        top: 'center',
                        left: "center",
                    }],
                yAxis: yAxis,
                xAxis: xAxis,
                series: seriesData,
            };
            if (_this.width && _this.height)
                _this.setAspectForOption(_this.width, _this.height, option);
            return option;
        };
        _this.setAspectForOption = function (width, height, option) {
            //console.log("width => ", width, ", height => ", height);
            var frW = setOrDef(_this.props.diagram, function (d) { return d.widthFillRatio; }, 0.8);
            var frH = setOrDef(_this.props.diagram, function (d) { return d.heightFillRatio; }, 0.8);
            var w = width * frW;
            var h = height * frH;
            //console.log("w => ", w, ", h => ", h);
            // a = w / h
            var a = _this.props.diagram.svgAspectRatio;
            var h1 = w / a * 0.8;
            if (h1 <= h) {
                //console.log("-1-");
                option.grid[0].width = w * 0.8;
                option.grid[0].height = h1;
            }
            else {
                //console.log("-2-");
                option.grid[0].width = h * a / 0.8;
                option.grid[0].height = h;
            }
            return option;
        };
        _this.onResize = function (width, height) {
            _this.width = width;
            _this.height = height;
            if (_this.instance) {
                var option = _this.setAspectForOption(width, height, _this.instance.getOption());
                _this.instance.setOption(option);
            }
        };
        _this.mapData = function () {
            if (_this.state.data) {
                return _this.state.data.data.series;
            }
            return undefined;
        };
        return _this;
    }
    return Pictorial;
}(SimpleDiagramBase));
export default Pictorial;
//# sourceMappingURL=Pictorial.js.map